import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import {
  listAllCategories,
  createProduct,
} from "@/lib/admin.functions";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { PageHeader, EMPTY_PROD, type Cat, type Prod } from "@/components/admin/shared";
import { ProductForm } from "@/components/admin/ProductForm";

export const Route = createFileRoute("/admin/products/new")({
  component: NewProductPage,
});

function NewProductPage() {
  const cats = useServerFn(listAllCategories);
  const create = useServerFn(createProduct);
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Cat[]>([]);
  const [value, setValue] = useState<Prod>({ ...EMPTY_PROD });
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    cats({})
      .then((c) => setCategories(c as Cat[]))
      .catch((e: any) => toast.error(e.message))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const payload: any = {
        ...value,
        long_description: value.long_description || null,
        video_url: value.video_url || null,
        dimensions: value.dimensions || null,
        power: value.power || null,
        weight: value.weight || null,
        meta_title: value.meta_title || null,
        meta_description: value.meta_description || null,
      };
      await create({ data: payload });
      toast.success("Skapad");
      navigate({ to: "/admin/products" });
    } catch (e: any) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <Loader2 className="h-5 w-5 animate-spin" />;

  return (
    <>
      <PageHeader title="Ny produkt" backTo="/admin/products" />
      <ProductForm
        value={value}
        categories={categories}
        busy={busy}
        onChange={setValue}
        onSave={save}
      />
    </>
  );
}
